import { render, staticRenderFns } from "./AlterarFormaPagamentoModal.vue?vue&type=template&id=8dc001bc&"
import script from "./AlterarFormaPagamentoModal.vue?vue&type=script&lang=js&"
export * from "./AlterarFormaPagamentoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports